import script from "./TheUserDataForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TheUserDataForm.vue?vue&type=script&setup=true&lang=js"

import "./TheUserDataForm.vue?vue&type=style&index=0&id=55579938&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55579938"]])

export default __exports__